import React from 'react';

import styled from 'styled-components';

import StyledTable from 'components/Companies/table/StyledTable';
import {
  type CommunicationTagConfig,
  getCommunicationTagConfig,
  getCommunicationTagLabel,
} from 'constants/communicationTags';
import { getFormattedDate } from 'helpers/dates';

const BaseTable = (props: any) => {
  return <StyledTable {...props} />;
};

export const RingCentralRecordsStyledTable = styled(BaseTable)`
  &&&&&& {
    .ant-table-tbody > tr.ant-table-row {
      cursor: pointer;

      > td.ant-table-cell {
        transition: background-color 0.15s ease;
      }

      &:hover > td.ant-table-cell {
        background: var(--background-gray);
      }
    }

    .ant-table-pagination.ant-pagination {
      padding-bottom: 12px;
    }

    .actions-hover-reveal {
      visibility: hidden;
    }

    .ant-table-cell-row-hover {
      .actions-hover-reveal {
        visibility: visible;
      }
    }
  }
`;

export const ValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const PrimaryValue = styled.span`
  font-family: var(--font-bold);
  font-size: 14px;
  color: var(--text-primary);
  word-break: break-word;
`;

export const SecondaryValue = styled.span`
  font-size: 12px;
  color: var(--text-secondary);
  word-break: break-word;
`;

export const BadgeGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 2px 8px;
  border: 1px solid var(--line-gray);
  border-radius: 999px;
  font-size: 12px;
  color: var(--text-secondary);
  background: var(--white);
  white-space: nowrap;
`;

export const RecordTag = styled.span<{ $tagConfig: CommunicationTagConfig }>`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 1px 7px;
  border: 1px solid ${({ $tagConfig }) => `var(${$tagConfig.borderColor})`};
  border-radius: 999px;
  font-size: 11px;
  color: ${({ $tagConfig }) => `var(${$tagConfig.textColor})`};
  background: ${({ $tagConfig }) => `var(${$tagConfig.backgroundColor})`};
  white-space: nowrap;
`;

export const EmptyValue = styled.span`
  color: var(--text-secondary);
`;

export const formatLabel = (value?: string | null) => {
  return getCommunicationTagLabel(value);
};

export const formatDate = (value?: string | null) => {
  if (!value) {
    return null;
  }

  return getFormattedDate(value, 'MMM D, YYYY h:mm A');
};

export const formatDuration = (value?: number | null) => {
  if (!value) {
    return null;
  }

  const minutes = Math.floor(value / 60);
  const seconds = value % 60;
  return minutes ? `${minutes}m ${seconds}s` : `${seconds}s`;
};

export const RingCentralRecordTag = ({ value }: { value?: string | null }) => {
  const tagConfig = getCommunicationTagConfig(value);

  return <RecordTag $tagConfig={tagConfig}>{tagConfig.label}</RecordTag>;
};

export const ContactValue = ({ name, phoneNumber }: { name?: string | null; phoneNumber?: string | null }) => {
  if (!name && !phoneNumber) {
    return <EmptyValue>Unknown</EmptyValue>;
  }

  return (
    <ValueContainer>
      <PrimaryValue>{phoneNumber || name}</PrimaryValue>
      {phoneNumber && name && <SecondaryValue>{name}</SecondaryValue>}
    </ValueContainer>
  );
};
